import SoftBadge from "components/SoftBadge";
import PropTypes from "prop-types";

export function ActiveDisabled(props) {
  return props.status ? <SoftBadge variant="contained" color="success" size="xs" badgeContent="Active" container /> : <SoftBadge variant="contained" color="error" size="xs" badgeContent="Disabled" container />
}

ActiveDisabled.propTypes = {
  status: PropTypes.bool.isRequired
}